import type { UnknownSerializedConstructor } from '@/types/schema';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export function useFireworksModelAndProvider(
  props: ManifestPreviewProps<UnknownSerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = (kwargs.model ?? null) as string | null;

  const modelLabel = model?.startsWith('accounts/fireworks/models/')
    ? model.split('/').at(-1)
    : model;

  return {
    model: modelLabel ?? null,
    provider: id,
  };
}
